module.exports = __webpack_public_path__ + "static/media/information_technology.6f319f87.png";